import _jsx2 from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _AppHelmet, _Normalize, _Reboot, _GlobalStyle;

var _excluded = ["component", "id", "props"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useCallback } from 'react';
import { nofollow } from '@treeum/nofollow';
import { Route, Switch } from 'react-router-dom';
import routes from 'routes';
import AppHelmet from 'components/AppHelmet';
import { GlobalStyle, Reboot, Normalize } from 'styleUtils';
import Wrapper from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var App = /*#__PURE__*/memo(function () {
  if (typeof document !== 'undefined') {
    var target = document.querySelector('body');
    nofollow({
      type: 'client',
      target: target
    });
  }

  var getRouteRender = useCallback(function (RouteComponent, props) {
    return function () {
      return /*#__PURE__*/_jsx(RouteComponent, _objectSpread({}, props));
    };
  }, []);
  var renderRoute = useCallback(function (_ref) {
    var component = _ref.component,
        id = _ref.id,
        props = _ref.props,
        routeProps = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/_createElement(Route, _objectSpread(_objectSpread({
      render: getRouteRender(component, props)
    }, routeProps), {}, {
      key: id
    }));
  }, []);
  return /*#__PURE__*/_jsx2(Wrapper, {}, void 0, _AppHelmet || (_AppHelmet = /*#__PURE__*/_jsx2(AppHelmet, {})), _Normalize || (_Normalize = /*#__PURE__*/_jsx2(Normalize, {})), _Reboot || (_Reboot = /*#__PURE__*/_jsx2(Reboot, {})), _GlobalStyle || (_GlobalStyle = /*#__PURE__*/_jsx2(GlobalStyle, {})), /*#__PURE__*/_jsx2(Switch, {}, void 0, routes.map(renderRoute)));
});
export default App;